import { ReactNode } from 'react';
import { t } from 'i18next';
import styled from 'styled-components';

import Icon from './Icon';

interface WrapperProps {
  children?: ReactNode;
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

interface LinkTextProps {
  children?: ReactNode;
  onClick?: any;
}

const LinkText = styled.a<LinkTextProps>`
  display: contents;
  cursor: pointer;
`;

const iconStyle = {
  marginRight: 5,
  width: '0.875em',
  fontSize: 'inherit',
};

const GoBack = ({ onClick }: { onClick: () => void }) => {
  return (
    <Wrapper>
      <LinkText onClick={onClick}>
        <Icon name={Icon.ARROW_LEFT} style={iconStyle} />
        {t('buttonLabelBack')}
      </LinkText>
    </Wrapper>
  );
};

export default GoBack;
